import { Store } from 'src/store/index';

const getProductDimensions = (store: Store) => store.editor.productDimensions;

export default getProductDimensions;
